/**
 * @file    exporters
 * @scope   SHARED
 * @summary CSV / Excel export of the legacy table (omitted columns removed, objects flattened).
 * @consumes helpers/exporFileUtilities, file-saver
 * @produces exportTableToCSV, exportTableToExcel
 * @sideEffects Triggers a file download.
 */
import { saveAs } from 'file-saver';
import {
  convertFieldObjectToValue,
  convertToCSV,
  exportToExcel,
  removeOmittedColumns,
} from 'helpers/exporFileUtilities';

const toExportableTable = (table: any, customWidgetConfig: any) => {
  const clonedTable = JSON.parse(JSON.stringify(table));
  return convertFieldObjectToValue(removeOmittedColumns(clonedTable), customWidgetConfig);
};

export const exportTableToExcel = async (
  table: any,
  displayName: string,
  showTotals: boolean,
  customWidgetConfig: any
) => {
  const exportable = toExportableTable(table, customWidgetConfig);
  await exportToExcel(exportable, displayName, showTotals, customWidgetConfig);
};

export const exportTableToCSV = (
  table: any,
  displayName: string,
  showTotals: boolean,
  customWidgetConfig: any
) => {
  const exportable = toExportableTable(table, customWidgetConfig);
  const csvData = convertToCSV(exportable, displayName, showTotals, customWidgetConfig);
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
  saveAs(blob, `${displayName || 'data'}.csv`);
};
